import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import { requiresCarrierPickupLocation } from 'checkout/checkout/helpers';
import AddressOnlyDisplay from 'common/components/address/AddressOnlyDisplay';
import { FormError } from 'common/components/layout';
import {
  listCarrierPickupLocations,
  resetCarrierPickupLocationsQuery,
  addCarrierPickupLocation,
  removeCarrierPickupLocation
} from 'redux/carrierPickupLocations/actions';

import PickupLocations from './components/PickupLocations';
import { carrierPickupLocationMessage } from './helpers';
import { validateCarrierPickupLocation } from './validators';

class CarrierPickupLocation extends Component {
  componentDidMount() {
    const { props } = this;
    if (!requiresCarrierPickupLocation(props.cart.data, props.settings)) {
      props.onEdit('shipping');
    }
    props.resetCarrierPickupLocationsQuery();
    props.listCarrierPickupLocations();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    if (data.carrierPickupLocationId === 'shipTo') {
      props.onEdit('shipping');
    } else {
      const { address } =
        props.carrierPickupLocation.data[data.carrierPickupLocationId];
      const successFunction = () => {
        props.onEdit('shipping');
      };
      props.addCarrierPickupLocation(address, successFunction);
    }
  };

  handleEdit = (e) => {
    const { props, state } = this;
    e.preventDefault();
    const data = {
      selectedShippingOptions: {
        shippingServiceId: state.shippingServiceId
      }
    };
    const successFunction = () => {
      props.onEdit('payment');
    };
    props.updateCart(data, successFunction);
  };

  handleRemove = (e) => {
    const { props } = this;
    e.preventDefault();
    const successFunction = () => {
      props.onEdit('shipping');
    };
    props.removeCarrierPickupLocation(successFunction);
  };

  handleContinue = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onEdit('shipping');
  };

  handleBack = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onEdit('customer');
  };

  render() {
    const { cart, settings, form, handleSubmit } = this.props;
    const { carrierPickupLocation } = this.props;
    if (cart.data && cart.data.carrierPickupLocation) {
      const { carrierPickupLocation: location } = cart.data;
      return (
        <>
          <h3>Local Pickup Locations</h3>
          <strong>{location.company}</strong>{' '}
          <a href="#" aria-label="Remove Location" onClick={this.handleRemove}>
            (Remove Location)
          </a>
          <br />
          <AddressOnlyDisplay address={location} />
          <br />
          <br />
          <div className="c7-checkout__content__buttons">
            <button
              type="button"
              onClick={this.handleContinue}
              className="c7-button"
            >
              Continue to shipping method
            </button>
            <a
              href="#"
              aria-label="Return to customer info"
              onClick={this.handleBack}
            >
              Return to customer information
            </a>
          </div>
        </>
      );
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Local Pickup Locations</h3>
        <p>{carrierPickupLocationMessage(settings)}</p>
        <PickupLocations
          carrierPickupLocation={carrierPickupLocation}
          settings={settings}
        />
        <div className="c7-checkout__content__buttons">
          <button type="submit" className="c7-button">
            Continue to shipping method
          </button>
          <a
            href="#"
            aria-label="Return to customer information"
            onClick={this.handleBack}
          >
            Return to customer information
          </a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = {
    carrierPickupLocationId: values.carrierPickupLocationId
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateCarrierPickupLocation(data);
  return errors;
};

const mapStateToProps = (state) => {
  const initialValues = {
    carrierPickupLocationId: 'shipTo'
  };
  return {
    cart: state.cart,
    carrierPickupLocation: state.carrierPickupLocation,
    initialValues
  };
};

CarrierPickupLocation = reduxForm({
  form: 'carrierPickupLocation',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(CarrierPickupLocation);

export default connect(mapStateToProps, {
  listCarrierPickupLocations,
  addCarrierPickupLocation,
  resetCarrierPickupLocationsQuery,
  removeCarrierPickupLocation
})(CarrierPickupLocation);
